import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { DefectsResponse } from 'features/PlacementsStatus/types';

interface PlacementsDefectsState {
  defects: DefectsResponse;
  loading: boolean;
}

const initialState: PlacementsDefectsState = {
  defects: {} as DefectsResponse,
  loading: false,
};

const reset: CaseReducer<PlacementsDefectsState> = () => initialState;

const setDefects: CaseReducer<PlacementsDefectsState, PayloadAction<DefectsResponse>> = (
  state,
  action,
) => {
  state.defects = action.payload;
};

export const placementsDefectsSlice = createSlice({
  name: 'placementsDefects',
  initialState,
  reducers: {
    loading: loading as IReducer<PlacementsDefectsState, boolean>,
    setDefects,
    reset,
  },
});

const {
  loading: setLoading,
  setDefects: setDefectsData,
  reset: setReset,
} = placementsDefectsSlice.actions;

export const getDefects =
  (placementId: number, subtype?: string): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<DefectsResponse>('/api/issues/', { placement: placementId, subtype: subtype })
      .then(({ data }) => {
        dispatch(setDefectsData(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setLoading, setReset };
